export default {
  deTopic: {
    derivative: {
      t0: "How did you learn about derivative transaction?",
      t1: "Understand",
      t2: "I don't understand",
      t3: "Unable to open an account.  Please understand derivatives knowledge first",
      t4: "You can select any of the following",
      t5: "1. Undergoing relevant training or attending course in",
      t6: "Regulatory Authority",
      t7: "Exchange",
      t8: "Tertiary Institution",
      t9: "Education Institution",
      t10: "Financial",
      t11: "2、By gaining prior relevant work experience in financial institutions such as a brokerage firm or bank, fund house or asset management firm, regulatory authority or exchange.",
      t12: "Regulated Licensed Person",
      t13: "Management",
      t14: "Derivatives Related Back Office",
      t15: "3、Executing five or more transactions in derivative products (whether traded on an exchange or not) within the past three years.",
      t16: "Right",
      t17: "Deny",
      t18: "Please upload the selected voucher",
      t19: "Tip: Please provide relevant vouchers according to the actual situation to help us provide you with better service and experience",
      t20: "Has there been any significant change in your financial situation within six months? (e.g. bankruptcy or liquidation, etc.)",
      t21: "Right",
      t22: "Deny",
      t23: "Please provide dates and details",
      t24: "Please enter...",
      t25: "Are you the ultimate beneficial owner  in relation to the account?",
      t26: "Going Financial  would not accept the Applicant who is not the ultimate beneficial owner",
      t27: "Right",
      t28: "Deny",
      t29: "Reason for application",
      t30: "Please enter...",
      t31: "* required",
      t32: "客戶確認及承諾",
      t33: "倘簽署本部份，客戶即聲明、同意及確認：",
      t34: "本人之前在高盈证券開立的户口資料己更改。附上更改帳戶資料表格。",
      t35: "本人聲明之前在高盈证券開立的户口資料沒有任何更改，亦同意高盈证券的條款及條件均與上述現有帳戶相同，包括授權操作帳戶之安排。",
      t36: "1.在不抵觸當地適用法律的情況下，本人同意高盈证券可向國內及海外的監管機構或稅務機構提供本人的資料以確立本人於任何司法管轄區的稅務責任。",
      t37: "2.因應國內或海外的監管機構或稅務機構需要，本人准許並同意高盈证券可按適用的法律、法規和指令在本人帳戶中扣留相關所須的金額款項。",
      t38: "本人謹此明確地、無條件地及不可取消地放棄本人因高盈证券因應國內或海外的監管機構或稅務機構需要而在本人帳戶中扣留相關所須的金額款項所發生的損失的索賠權利，及本人須賠償予高盈证券因此而引起的法律責任。",
      t39: "3. 本人保證所提供的任何資料如有變更，需於三十日內通知高盈证券。",
      t40: "聲明",
      t41: "1. 倘若之前在高盈证券開立的戶口資料沒有任何更改，本人同意將原於高盈证券之現有帳戶之資料用作開設額外帳戶之用。",
      t42: "2. 倘若之前在高盈证券開立的戶口資料己更改, 本人同意在高盈证券的要求下，本人將提供己更改資料的相關證明文件予高盈证券作更改現有帳戶資料及開設額外帳戶之用。",
      t43: "3. 本人證實已收取閱讀及明白 證券/ 期貨交易帳戶條款及條件(條款及條件)包括有關隱私政策及客戶協議。",
      t44: "4. 高盈证券有權在任何時間以書面通知更改條款及條件，除非高盈证券收到本人終止帳戶通知，否則表示本人接受該更改條款及條件。",
      t45: "5. 本人現聲明及確認已獲得並完全瞭解按照本人選擇的語言之風險披露聲明，本人已獲邀閱讀及簽署風險披露聲明，如有疑問可徵求獨立意見。",
      t46: "6. 本人/吾等明白高盈证券有最終接納開立額外帳戶與否之權利。",
      t47: "本人/吾等同意输入登录密码确认签名同时用于现有客户加开额外交易账户申请表、开户申请表、衍生产品基本知识课程、W-8BEN表格、风险承受能力问卷、风险披露声明、客户常设授权、税务居民数据、FATCA、投资者识别及场外证券汇报制度之客户资料收集声明和其他适用文件。",
      t48: "本人/吾等同意输入登录密码确认签名同时用于现有客户加开额外交易账户申请表、帳戶資料更改表格、开户申请表、衍生产品基本知识课程、W-8BEN表格、风险承受能力问卷、风险披露声明、客户常设授权、税务居民数据、FATCA、投资者识别及场外证券汇报制度之客户资料收集声明和其他适用文件。",
      t49: "I get it.",
      t50: "Do it.",
      t51: "If you need to open an additional trading account, please contact customer service"
    }
  },
  treemap:{
    t0: "The HK stocks ",
    t1: "The US stocks ",
    t2: "quotes are 15-min delayed",
    t3: "Heat Map"
  }
};
